import { render } from "./LoadingSpinner.vue?vue&type=template&id=23814b32&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=23814b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23814b32"]])

export default __exports__